import { styled } from '@mui/material';
import { SPACES } from '@/constants/sizes';
import { colorPalettes, colorPalettes as colorPalette } from '@/context/theme';
import { Flex } from '@/components/base/Flex';
import { Text } from '@/components/base/Text';

const StyledProviderBox = styled(Flex)`
  position: relative;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-content: center;
  margin-right: ${SPACES['small']};
  margin-bottom: ${SPACES['medium']};
`;

export const StyledProviderName = styled(Text)`
  padding-top: 0.7rem;
  width: 6rem;
  text-align: center;
  color: ${({ theme }) =>
    colorPalette[theme.palette.mode].components.ProviderBoxesView.ProviderName
      .color};
`;

interface StyledProviderProps {
  disabled?: boolean;
}
export const StyledProvider = styled('div')<StyledProviderProps>`
  display: flex;
  border: 1px solid
    ${({ theme }) =>
      colorPalettes[theme.palette.mode].components.ProviderBoxesView
        .ProviderWrapper.border.color};
  border-radius: 6px;
  height: 6rem;
  width: 6rem;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  align-content: center;

  ${({ disabled, theme }) =>
    disabled
      ? `
      cursor: not-allowed;
      opacity: 0.1;
      filter: brightness(99%)
    `
      : `
      cursor: pointer;
      &:hover {
        border: 1px solid ${
          colorPalette[theme.palette.mode].components.ProviderBoxesView
            .ProviderWrapper.hover.border.color
        };
        background-color: ${
          colorPalette[theme.palette.mode].components.ProviderBoxesView
            .ProviderWrapper.hover.background.color
        };
      }
    `}
  img {
    width: 2.4rem;
  }
`;

export default StyledProviderBox;
